<template>


  <div id="app" v-if="onLine">
    <b-progress-bar
       v-for="tour in tours"
        :key="tour.id"
        :name="tour.name"
        :steps="tour.data"
        :callbacks="vueToursCallbacks(tour.id)"
        >
    </b-progress-bar>
    <md-progress md-indeterminate class="md-accent" v-if="IsProgressVisible" style="top: 64px;"></md-progress>
    <SideBar></SideBar>
    <div :class="parseInt(this.$sessionsStorage.get('userId'))>0?ContentMargin=='250'?'appMargin300' :'appMargin0':''">
      
      <div :class="parseInt(this.$sessionsStorage.get('userId'))>0?'content-div':''" >
        <transition name="fade" mode="out-in" appear>
          <router-view></router-view>
        </transition> 
      </div>
    </div> 
  </div>
    <div  id="app" v-else>
      <ConnectionLost></ConnectionLost>
    </div>
</template>

 
<script>
import SideBar from "./sideBar.vue";
import ConnectionLost from "./connectionLost.vue";
import { deviceType } from "../helper/enum/deviceType.js";
export default {
  beforeMount() {
    let width = window.innerWidth;
    this.setDeviceType(width);
    window.onresize = e => {
      width = e.target.innerWidth || 900;
      this.setDeviceType(width);
    };
  },
data() {
    return {
      onLine: navigator.onLine,
      tours: [],
      vueToursCallbacks: id => ({
        onFinish: () => this.handleWalkThroughFinished(id),
        onSkip: () => this.handleWalkThroughFinished(id)
      })
    };
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    if (this.IsLoginPage || this.DeviceType == deviceType.PHONE) {
      this.$store.dispatch("setSidebarMargin", 50);
    } else {
      this.$store.dispatch("setSidebarMargin", 50);
    }
  },

  beforeDestroy() {},
  destroyed() {},
  components: {
    SideBar,
    ConnectionLost
  },
  computed: {
    SideBarMargin() {
      return { "margin-left": `${this.$store.getters.appSideBarMargin}px` };
    },
    DeviceType() {
      return this.$store.getters.appDeviceType;
    },
    IsProgressVisible() {
      return this.$store.getters.appIsProgressVisible;
    },
    ContentMargin() {
      if (this.$store.getters.appContentMargin == "250") {
        return this.$store.getters.appContentMargin;
      }
    },
    IsLoginPage() {
      return this.$store.getters.appCurrentRoute == "/login" ? false : false;
    }
  },
  methods: {
    setDeviceType(width) {
      if (width < 600) {
        this.$store.dispatch("setDeviceType", deviceType.PHONE);
      } else if (width > 600 && width < 900) {
        this.$store.dispatch("setDeviceType", deviceType.TABLET);
      } else {
        this.$store.dispatch("setDeviceType", deviceType.DESKTOP);
      }
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
      if (this.onLine) {
        // document.getElementById("app").style.background = "#3876D2";
      } else {
        // document.getElementById("app").style.background = "#fff";
      }
    }
    
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900&family=Lobster&display=swap');
body {
  background: #f1f1f1;
 font-family: 'Lato', sans-serif !important;
}
h1, h2, h3, h4, h5, h6{
  font-family: 'Lato', sans-serif !important;
}
.wrapper {
  text-align: center;
}
.content-div {
  padding: 66px 0px 0px 4px;
  /* max-width: 1000px;  */
  margin: auto;
}

.divider {
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #eaecef;
  border-top: 1px solid #eaecef;
}

.footer {
  display: flex;
  flex: 1;
}

.left-sidenav-container .md-theme-default.md-toolbar {
  background-color: #0e0052;
  color: #000;
}

.md-theme-default.md-toolbar.admin-toolbar {
  position: fixed;
  z-index: 52;
  left: 0;
  right: 0;
  top: 0;
  padding: 0px;
}

.top-fixed-bar {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  /* background: #002b49; */
  background: white;
  color: #ffffff;
  padding-left: 10px;
}

.md-sidenav-backdrop {
  display: none;
}

.md-sidenav.md-active .md-sidenav-content {
  margin-top: 56px;
  box-shadow: none;
  /* transition: 0.3s;
  transition: 0.3s; */
}

.md-theme-default.md-list .md-list-item-expand .md-list-item-container {
  background: none !important;
}
.md-theme-default.md-list {
  color: #000;
}
.md-list-item.md-inset .md-list-item-container {
  padding-left: 55px !important;
}
.md-sidenav-content {
  margin-top: 65px;
  position: fixed !important;
  z-index: 50 !important;
  overflow: hidden !important;
  /* transition: 0.3s; */
}
.md-sidenav-content:hover {
  margin-top: 65px;
  position: fixed !important;
  z-index: 50 !important;
  /* transition: 0.3s; */
  overflow-y: auto !important;
}
.base-div {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.dashboard-card {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.md-toolbar.md-theme-default {
  /* border-bottom: 0.5px solid rgba(0, 0, 0, 0.12) !important; */
  height: 63.5px;
}

.top-left {
  padding-left: 10px;
}

.md-toolbar-container img {
  height: 51px;
  padding-left: 0px;
}

.md-card-actions .md-button {
  background-color: rgba(153, 153, 153, 0.2);
}

.md-select-content,
.md-menu-content {
  width: 50% !important;
  max-width: 50% !important;
}
.md-icon.md-theme-default.material-icons {
  color: #002b49;
  border-radius: 7px;
  /* background: white; */
}
.md-theme-default.md-sidenav .md-sidenav-content {
  background-color: #002b49;
  color: rgba(0, 0, 0, 0.87);
  /* transition: 0.3s; */
  margin-top: 0px !important;
}
.ui.selection.dropdown .menu > .item:hover {
    color: #33b6c7;
    z-index: 3;
}

/* GLOBAL SEARCH Priyanshu Singh Start */
.section-global-search {
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10999;
  position: fixed;
  background: inherit;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background-color: rgba(10, 10, 10, 0.75);
}

.search-wrapper {
  height: 100%;
  width: 100%;
  position: relative;
}

.search-wrapper .close-backdrop {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  height: 100%;
  position: absolute;
}

.search-container {
  top: 15%;
  left: 50%;
  width: 55vw;
  min-height: 45px;
  overflow: hidden;
  border-radius: 10px;
  position: absolute;
  z-index: 999;
  background-color: #f8f8f8;
  transition: height 0.3s ease-in-out;
  box-shadow: 2.5px 2.5px 5px 5px #2e2e2eeb;
  transform: translateX(-50%);
  border: 2px solid var(--blue);
}

.app-search {
  height: 100%;
  width: 40px;
  /* background: #fff url("../img/icons/search-global.svg") no-repeat; */
  background-position: center center;
  background-size: 18px;
  cursor: pointer;
}

.search-container input {
  width: 100%;
  height: 45px;
  font-size: 16px;
  padding: 0 15px 0 40px;
  border: none;
  /* background: #fff url("../img/icons/search-global.svg") no-repeat; */
  background-position: 12.5px center;
  background-size: 18px;
}

.search-container li:not(:last-child) {
  border-bottom: 1px solid #d3d3d3;
}

.search-container li:hover {
  border-bottom: 1px solid transparent;
}

.search-container a {
  color: #5f6972;
  display: block;
  padding: 7px 5px;
  font-size: 16px;
  border-radius: 5px;
  transition: 0.2s ease-in-out;
}

.search-container a:hover {
  padding: 7px 10px;
  color: #fff;
  background-color: var(--blue);
}
.search-container a:hover .router-small-font {
  color: #fff;
}

.search-container a:active .router-small-font,
.search-container a.is-active .router-small-font {
  color: #fff;
}

.search-container a:active,
.search-container a.is-active {
  padding: 7px 10px;
  color: #fff;
  background-color: var(--blue);
}

.search-container a:hover,
.search-container a:focus {
  outline: none !important;
}
.app-search {
  height: 100%;
  width: 40px;
  background: #fff url("../css_profile/img/icons/search-global.svg") no-repeat;
  background-position: center center;
  background-size: 18px;
  cursor: pointer;
}

.app-search input {
  width: 100%;
  height: 60px;
  border: none;
  padding: 0 5px;
  position: relative;
}
/* GLOBAL SEARCH Priyanshu Singh End */
/* .fade-enter-active,
.fade-leave-active {
  transition-duration: 0.1s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
} */
</style>



// WEBPACK FOOTER //
// app.vue?63860e43